import { ArbeitenBezeichnungen } from '@/types/service-response'

export class WorkDescription {
  private constructor (
    readonly id: number,
    readonly language: number,
    readonly workId: number,
    readonly description: string
  ) {}

  static createListFromResponse (data: ArbeitenBezeichnungen[]): Array<WorkDescription> {
    return data.map((item: ArbeitenBezeichnungen) => {
      return new WorkDescription(
        item.ID,
        item.Sprache,
        item.Arbeit,
        item.Bezeichnung ? item.Bezeichnung : ''
      )
    })
  }
}
